const BurgerSpinner = (): JSX.Element => (
    <div className="burger-spinner">
        <div className="burger-spinner__bun-bottom" />
        <div className="burger-spinner__lettuce" />
        <div className="burger-spinner__patty" />
        <div className="burger-spinner__cheese" />
        <div className="burger-spinner__tomato" />
        <div className="burger-spinner__bun-top">
            <div className="burger-spinner__seed burger-spinner__seed--1" />
            <div className="burger-spinner__seed burger-spinner__seed--2" />
            <div className="burger-spinner__seed burger-spinner__seed--3" />
        </div>
    </div>
);

export default BurgerSpinner;
